import whenDomReady from 'when-dom-ready';

function initialise() {
  const container = document.querySelector('.js-account-upload');
  const mb = 1000000;

  if (container === null) {
    return;
  }

  const input = document.querySelector('.js-account-upload-input');
  const trigger = document.querySelector('.js-account-upload-trigger');
  const preview = document.querySelector('.js-account-upload-preview');
  const reader = new FileReader();

  // Redirect click onto hidden input
  trigger.addEventListener('click', () => input.click());

  // Set preview SRC on file upload
  reader.onload = e => {
    preview.style.backgroundImage = `url('${e.target.result}')`;
  };

  // Add event to input to handle 'change' for file uploads and set the reader URL
  input.addEventListener('change', () => {
    if (input.files && input.files[0]) {
      const file = input.files[0];

      if (file.size > mb) {
        // Round to 1 decimal place
        const prettySize = Math.round((file.size / mb) * 10) / 10;
        alert(`${prettySize}mb is too large, please upload a file less than 1mb`);
      } else {
        reader.readAsDataURL(input.files[0]);
      }
    }
  });
}

whenDomReady().then(initialise);

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initialise);
